module.exports = __webpack_public_path__ + "static/media/non-vegetarian.ab7641b8.svg";